import { render, staticRenderFns } from "./read.vue?vue&type=template&id=a3eb1f72&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"
import style0 from "./read.vue?vue&type=style&index=0&id=a3eb1f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3eb1f72",
  null
  
)

export default component.exports